import styled from 'styled-components'

// eslint-disable-next-line import/prefer-default-export
export const SalaryWrapper = styled.article`
  width: 100%;

  .sliderArea {
    padding: 0 15px;
  }
  .rc-slider-track {
    background-color: #0d2160;
  }

  .rc-slider-handle {
    border: solid 3px #0d2160;
    width: 22px;
    height: 22px;
    margin-top: -10px;
  }
  .rc-slider-tooltip-inner {
    color: white;
    background-color: #0d2160 !important;
    padding: 6px 8px;
    height: 32px;
    font-size: 13px;
    font-weight: 700;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    background-color: #6c6c6c;
    border-radius: 6px;
    box-shadow: none;
  }
  .rc-slider-tooltip-placement-top .rc-slider-tooltip-arrow {
    border-top-color: #0d2160 !important;
  }
`
